export default "__VITE_ASSET__BW0KIIl4__"